<template>
  <div class="p-1">
    <AlgoliaGifts
      :countries="countries"
      :labels="labels"
      search-enabled
      @gift-click="onGiftClick"
    />
    <PreviewGiftDetailsModal
      :show="isGiftSelectionModalShown"
      :gift-id="clickedGift?.gift_id"
      @cancel="closeGiftSelectionModal"
      @close="closeGiftSelectionModal"
      @primary-click="goToCreateAccountPage"
    />
  </div>
</template>
<script setup>
import AlgoliaGifts from "@/components/gifts/algolia/AlgoliaGifts.vue"
import PreviewGiftDetailsModal from "@/components/gifts/PreviewGiftDetailsModal.vue"
import { ref } from "vue"

const props = defineProps({
  countries: Array,
  labels: Array,
  create_account_url: String,
})

const clickedGift = ref(null)
const onGiftClick = gift => {
  clickedGift.value = gift
  isGiftSelectionModalShown.value = true
}

const isGiftSelectionModalShown = ref(false)
const closeGiftSelectionModal = () => {
  isGiftSelectionModalShown.value = false
}
const goToCreateAccountPage = () => {
  window.open(props.create_account_url, "_blank").focus()
}
</script>
